import {
  BASE_URL_VCLAIM,
  BASE_URL_WMS_BPJS,
  instance1,
  instance2,
  SESSION_ID_EMR,
  V1,
} from "App/constants"
import {
  defaultDateDisplay,
  isNull,
  oneMonthBeforeToday,
  today,
  toDayIndo,
} from "App/utils/helpers"
import { makeStyles } from "@material-ui/core/styles"
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme"
import { useState, useEffect } from "react"
import {
  LIST_URL_REGISTRASI,
  TYPE_REGISTRASI_RAWAT_INAP,
  TYPE_REGISTRASI_RAWAT_JALAN,
} from "utils/registrations"
import { endOfDay, toFirstHoursDay, validUTC } from "utils/dates"
import { prefixNoRM } from "../../utils"
import { getToken } from "App/utils/cookies"
import { URL_SETTING } from "utils/all"
import moment from "moment"

export const urlGetRawatJalanOnsite =
  "/registration/registration/listregistration_onsiterjalan"
export const urlGetRawatJalanOnsiteExport =
  "/registration/registration/listregistration_onsiterjalan_export"

export const urlFilterInternal = "/patient/listpatientsfilter_regrj"
export const urlFilterExternal = "/patient/listpatientsfilter_external"
export const urlFilterBooking = "/registration/registration/verif_bookingfilter"

export const urlGetRegistrasiFile = "/registration/regis_file/listregis_file"
export const urlAddRegistrationFile = "/registration/regis_file/addregis_file"
export const urlDeleteRegistrationFile =
  "/registration/regis_file/deleteregis_file"

export const RESET_STATE_KUNJUNGAN_RAWAT_JALAN = {
  jenis_layanan_id: "",
  kelaskunjungan_id: 6,
  jenis_kunjungan: "",
  patients_id: "",
  date: today(true),
  nama_rm: "",
  gender: "",
  umur: "",
  nohp: "",
  phone_number: "",
  address_now: "",
  pekerjaan: "",
  penanggung: "",
  nik: "",
  norm: "",
  type_norujukan: "pcare",
  waktu_estimasi_dilayani: "",
  jenis_layanan_print: "Rawat Jalan",

  company_id: null,
  company_name: "Pilih Perusahaan",

  insurance_no: "",

  insurance_id: null,
  insurance_name: "Pilih Asuransi",

  whycancel: "",
  norujukan: "",
  nokontrol: "",

  schedule_doctor_id: "",

  doctor_id: "",
  doctor_name: "Pilih Dokter",
  spesilais_name: "",

  jenis_antrian: "1",
  poliklinik_id: null,
  poli_name: "Pilih Poliklinik",

  layanan_id: "",
  layanan_name: "",
  layanan_ruang_id: "",
  jenisrm: 2,

  is_from_booking: false,
  antrianno: "",
  initial: "",

  booking_id: "",

  nama_dokter: "",
  day: "",
  time_start: "",
  time_finish: "",

  sebab_sakit: 0,

  nosep: "",
  no_sep: "",

  is_update_jadwal: false,
  isexternalrm: false,
  typeofcare_code: "RJALAN",

  kode_dpjp: "",
  kode_dpjp_nama: "",

  doctor_kodebridge: "",
  pasien_prioritas: 0,
  spesialis_name: "",

  id_antrian_loket: "",
  tanggal_antrianloket: "",
  tanggal_antrianloket_proses: "",

  loket_antriantype_code: "",
  loket_antrianno: "",

  validasi_bpjs: true,
  remark: "",

  cara_masuk: "other",
  cara_masuk_name: "Lain-lain",
}

export const selectJenisKunjungan = [
  {
    value: "",
    label: "Pilih Jenis Kunjungan",
  },
  {
    value: "10",
    // value: "1",
    label: "Pasien Non BPJS",
  },
  {
    value: "1",
    label: "Rujukan FKTP",
  },
  {
    value: "2",
    label: "Rujukan Internal",
  },
  {
    value: "3",
    label: "Kontrol",
  },
  {
    value: "4",
    label: "Rujukan Antar RS",
  },
]

export const validasiTypeRegistrasi = [
  {
    simrs: "rj",
    sep: "rawat jalan",
  },
  {
    simrs: "ri",
    sep: "rawat inap",
  },
  {
    simrs: "igd",
    sep: "rawat jalan",
  },
]

export const getNoRencanaKontrol = async (
  from,
  to,
  filter,
  type = TYPE_REGISTRASI_RAWAT_JALAN,
) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        session_id: SESSION_ID_EMR,
        tgl_awal: from,
        tgl_akhir: to,
        filter: filter.toString(),
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/data-no-surat-kontrol`,
        },
      },
    )

    const response = api.data.body
    if (parseInt(response.metaData.code) === 200) {
      let filterByType = []

      if (
        !isNull(response.response.list) &&
        type === TYPE_REGISTRASI_RAWAT_INAP
      ) {
        filterByType = response.response.list.filter(
          (item) => item.jnsPelayanan === type,
        )
      } else {
        filterByType = response.response.list
      }

      return {
        state: true,
        data: filterByType,
      }
    } else {
      return {
        state: false,
        message: response.metaData.message,
      }
    }
  } catch (error) {}
}

export const getNoRencanaKontrolUtama = async (
  tanggal,
  filter,
  nomor_kartu,
  type = TYPE_REGISTRASI_RAWAT_JALAN,
) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        session_id: SESSION_ID_EMR,
        bulan: moment(tanggal).format("MM"),
        tahun: moment(tanggal).format("YYYY"),
        nomor_kartu: nomor_kartu,
        filter: filter.toString(),
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/rencana-kontrol/data-no-kartu`,
        },
      },
    )

    const response = api.data.body
    if (!isNull(response?.metaData?.code)) {
      if (parseInt(response.metaData.code) === 200) {
        let filterByType = []
        if (
          !isNull(response.response.list) &&
          type === TYPE_REGISTRASI_RAWAT_INAP
        ) {
          filterByType = response.response.list.filter(
            (item) => item.jnsPelayanan === type,
          )
        } else {
          filterByType = response.response.list
        }
        return {
          state: true,
          data: filterByType,
        }
      } else {
        return {
          state: false,
          message: response?.metaData?.message,
        }
      }
    } else {
      return {
        state: false,
        message: !isNull(response?.message)
          ? response?.message
          : !isNull(response?.metaData?.message)
          ? response?.metaData?.message
          : "Data Tidak Ditemukan !",
      }
    }
  } catch (error) {
    return {
      state: false,
      message:
        error?.response?.data.body?.metaData?.message ??
        "Data Tidak Ditemukan !",
    }
  }
}

export const deleteKunjunganRawatJalanById = async (id) => {
  try {
    await instance2.post(
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.delete_rawat_jalan,
      {},
      {
        headers: {
          registration_id: id,
        },
      },
    )
    return {
      state: true,
      message: "Berhasil menghapus data",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const validasiLayananPasien = async (params) => {
  try {
    const api = await instance2.get(
      "/registration/jenis-kunjungan/validasi-jenis-kunjungan",
      {
        params,
      },
    )
    if (api.data.status === 200) {
      return {
        state: true,
        data: api.data.data,
        message: api.data.message,
      }
    } else {
      return {
        state: false,
        data: api.data.data,
        message: api.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {
        text: "",
      },
      message: error?.response?.data?.message,
    }
  }
}

export const getNoRujukInternal = async (no_rm, pages, limit) => {
  try {
    const api = await instance2.get(
      "/registration/registration/get-rencana-rujuk",
      {
        params: {
          no_rm: no_rm,
          pages: pages,
          limit: limit,
        },
      },
    )
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.meta.count),
          pages: parseInt(res.meta.pages),
          limit: parseInt(res.meta.limit),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const RESET_STATE_FORM_FILTER = {
  type_search: 0,
  type_rm: 0,
  qword: "",
  first_date: oneMonthBeforeToday(false),
  finish_date: endOfDay(true),
  status: 0,
  is_cancel: 0,

  policode: null,
  poliname: "Pilih Poliklinik",

  doctor: null,
  doctor_name: "Pilih Dokter",

  pages: 1,
  limit: 10,
}

export const valueJenisRm = [
  {
    value: 2,
    label: "Internal",
  },
  {
    value: 1,
    label: "External",
  },
]

export const valueJenisAntrian = [
  {
    value: 1,
    label: "Poliklinik",
  },
  {
    value: 2,
    label: "Layanan",
  },
]

export const valueTypeSearch = [
  {
    label: "Semua",
    value: 0,
  },
  {
    label: "ID RM",
    value: 1,
  },
  {
    label: "ID Kunjungan",
    value: 7,
  },
  {
    label: "Nama",
    value: 2,
  },
  {
    label: "ID Tagihan",
    value: 3,
  },
  {
    label: "No Asuransi",
    value: 4,
  },
  {
    label: "No SEP",
    value: 5,
  },
  {
    label: "Created By",
    value: 6,
  },
]

export const validation = (formData, ASURANSI_BPJS_ID) => {
  if (isNull(formData.jenis_layanan_id)) {
    return {
      state: false,
      message: "Jenis Layanan tidak boleh kosong",
    }
  } else if (isNull(formData.nohp)) {
    return {
      state: false,
      message: "NO HP tidak boleh kosong",
    }
  } else if (formData.company_id === "") {
    return {
      state: false,
      message: "Perusahaan tidak boleh kosong",
    }
  } else if (isNull(formData.cara_masuk)) {
    return {
      state: false,
      message: "Cara masuk tidak boleh kosong",
    }
  } else if (isNull(formData.jenis_antrian)) {
    return {
      state: false,
      message: "Jenis Antrian tidak boleh kosong",
    }
  } else if (formData.insurance_id === ASURANSI_BPJS_ID) {
    if (isNull(formData.insurance_no)) {
      return {
        state: false,
        message: "Jika BPJS, No Asuransi tidak boleh kosong",
      }
    } else if (isNull(formData.norujukan)) {
      return {
        state: false,
        message: "Jika BPJS, No Rujukan tidak boleh kosong",
      }
    } else {
      return {
        state: true,
      }
    }
  } else {
    return {
      state: true,
    }
  }
}

export const STYLE_MASTER_GUDANG_UTAMA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const getByFilterKunjunganRawatJalan = async (
  formFilter,
  pages,
  limit,
) => {
  try {
    const api = await instance2.get(urlGetRawatJalanOnsite, {
      headers: {
        type_search: formFilter.type_search,
        type_rm: formFilter.type_rm,
        qword: formFilter.qword,
        first_date: validUTC(formFilter.first_date),
        finish_date: validUTC(formFilter.finish_date),
        policode: formFilter.policode,
        status: formFilter.status,
        is_cancel: formFilter.is_cancel,
        doctor:
          formFilter.doctor === null
            ? ""
            : formFilter.doctor.map(function (item) {
                return item["value"]
              }),

        pages,
        limit,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterKunjunganRawatJalanExport = async (formFilter) => {
  try {
    const api = await instance2.get(urlGetRawatJalanOnsiteExport, {
      headers: {
        type_search: formFilter.type_search,
        type_rm: formFilter.type_rm,
        qword: formFilter.qword,
        first_date: validUTC(formFilter.first_date),
        finish_date: validUTC(formFilter.finish_date),
        status: formFilter.status,
        is_cancel: formFilter.is_cancel,

        doctor:
          formFilter.doctor === null
            ? ""
            : formFilter.doctor.map(function (item) {
                return item["value"]
              }),
        policode: formFilter?.policode,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getFileByRegistrationId = async (id) => {
  try {
    const api = await instance2.get(urlGetRegistrasiFile, {
      headers: {
        regis_id: id,
      },
    })
    const res = api.data
    return {
      state: true,
      data: res.body,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteFileByRegistrationId = async (id) => {
  try {
    const api = await instance2.post(
      urlDeleteRegistrationFile,
      {},
      {
        headers: {
          idregis_file: id,
        },
      },
    )
    const res = api.data
    return {
      state: true,
      data: res.body,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const convertJenisGudangUtama = (id) => {
  switch (id) {
    case 1:
      return "Perbekalan Farmasi"

    case 2:
      return "Logistik"

    case 3:
      return "Fix Asset"

    default:
      return "Tidak ditemukan"
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    minWidth: "40px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "patients_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "rm_name",
    disablePadding: false,
    label: "NAMA RM",
    align: "left",
    minWidth: "175px",
  },
  {
    id: "tagihan_id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL REGISTRASI",
    align: "left",
    minWidth: "170px",
  },

  {
    id: "iscancel",
    disablePadding: false,
    label: "STATUS",
    align: "center",
    minWidth: "110px",
  },
  {
    id: "nohp",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_phone_number",
    disablePadding: false,
    label: "NO TLP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "doctor_fullname",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "doctor_poliklinik_name",
    disablePadding: false,
    label: "POLI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "jadwal",
    disablePadding: false,
    label: "JADWAL PRAKTEK",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "perusahaan",
    disablePadding: false,
    label: "PERUSAHAAN",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "insurance_name",
    disablePadding: false,
    label: "ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "insurance_no",
    disablePadding: false,
    label: "NO ASURANSI",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "nosep",
    disablePadding: false,
    label: "NO SEP",
    align: "left",
    minWidth: "150px",
    sort: false,
  },
  {
    id: "antrianno",
    disablePadding: false,
    label: "NO ANTRIAN",
    align: "left",
    minWidth: "120px",
  },

  {
    id: "date_ob",
    disablePadding: false,
    label: "TANGGAL LAHIR",
    align: "left",
    sort: false,
    minWidth: "130px",
  },
  {
    id: "umur",
    disablePadding: false,
    label: "UMUR",
    align: "left",
    sort: false,
    minWidth: "165px",
  },
  {
    id: "nama_ppk_perujuk",
    disablePadding: false,
    label: "PPK PERUJUK",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "nama_hak_kelas",
    disablePadding: false,
    label: "HAK KELAS",
    align: "left",
    sort: false,
    minWidth: "140px",
  },
  {
    id: "whycancel",
    disablePadding: false,
    label: "CATATAN BATAL",
    align: "left",
    sort: false,
    minWidth: "250px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    sort: false,
    minWidth: "250px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const valueSebabSakit = [
  {
    value: "bukan kecelakaan",
    label: "Bukan Kecelakaan",
  },
  {
    value: "kecelakaan",
    label: "Kecelakaan",
  },
]

const labelStatus = {
  1: "Praktek",
  2: "Tidak Praktek",
  3: "Tutup",
}

export const useScehuldeDokter = (idDokter = 1) => {
  const DEFAULT_OPTION = [
    {
      label: "Pilih",
      value: "",
    },
  ]

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      if (idDokter !== "") {
        const api = await instance1.get(
          LIST_URL_REGISTRASI.kunjungan_rawat_jalan.schedule_dokter,
          {
            headers: {
              iddoctor: idDokter,
            },
          },
        )
        const res = api.data
        return res.body
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      const res = await get()
      if (res) {
        const data = [
          {
            value: "",
            label: "Pilih",
          },
        ]

        res.map((item) => {
          const labelPerubahan = item.perubahan
            ? `| Perubahan dr ${toDayIndo(item.day_lama)}, ${
                item.time_start_lama
              } - ${item.time_finish_lama}`
            : ""

          return data.push({
            value: item.id,
            label: `${toDayIndo(item.day)} ${item.time_start} - ${
              item.time_finish
            } ${labelPerubahan} [${labelStatus[item.status_jadwal]}]`,
            disabled: parseInt(item.status_jadwal) === 1 ? false : true,
          })
        })

        setState(data)
      }
    })()
  }, [idDokter]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useLayananRuang = (layananId) => {
  const DEFAULT_OPTION = [
    {
      label: "Pilih",
      value: "",
    },
  ]

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      if (layananId !== "") {
        const api = await instance1.get(
          LIST_URL_REGISTRASI.kunjungan_rawat_jalan.layanan_ruang,
          {
            headers: {
              layanan_id: layananId,
            },
          },
        )
        const res = api.data
        return res.body
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      const res = await get()
      if (res) {
        const data = [
          {
            value: "",
            label: "Pilih",
          },
        ]

        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          })
        })

        setState(data)
      }
    })()
  }, [layananId]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const getFilterModalBooking = async (formData, pages, limit) => {
  try {
    const api = await instance2.get(
      "/registration/registration/verif_bookingfilter_regrj",
      {
        headers: {
          id_booking: formData.id_booking,
          doctor_id: formData.doctor_id,
          schedule_doctor_id: formData.schedule_doctor_id,
          name: formData.name,
          dates: toFirstHoursDay(formData.dates),
          pages,
          limit,
        },
      },
    )
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
      meta: {
        count: 0,
      },
    }
  }
}

export const createAntrianJKN = async (formData) => {
  try {
    /**
     * jenispasien = JKN/NON JKN
     * nomorreferensi = {norujukan/kontrol pasien JKN,diisi kosong jika NON JKN}
     */
    await instance1.post(
      `/bridging`,
      {
        kode_booking: "16032021A001", // booking ID
        jenis_pasien: "JKN",
        nomor_kartu: formData.insurance_no,
        nik: formData.nik,
        no_hp: formData.no_hp,
        kode_poli: "ANA",
        nama_poli: formData.poli_name,
        pasien_baru: 0,
        no_rm: formData.norm,
        tanggal_periksa: today(false),
        kode_dokter: 12345,
        nama_dokter: formData.nama_dokter,
        jam_praktek: `${formData.time_start}-${formData.time_finish}`,
        jenis_kunjungan: 1,
        nomor_referensi: formData.norujukan,
        nomor_antrean: `${formData.initial}-${formData.antrianno}`,
        angka_antrean: formData.antrianno,
        estimasi_dilayani: 7200000, // dalam milisecond 2 jam
        sisa_kuota_jkn: 5, //
        kuota_jkn: 30, // kuota mobile
        sisa_kuota_non_jkn: 5,
        kuota_non_jkn: 30, // kuota dokter
        keterangan: "",
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_WMS_BPJS}/${V1}/rsannisa/ws/bpjs/antrean/add`,
        },
      },
    )
  } catch (error) {}
}

export const defaultPrint = (
  formData,
  url,
  registrationId,
  printerEnv,
  kode_setting,
) => {
  const noRM = prefixNoRM(formData.patients_id)
  const noAntrian = `${formData.initial}${formData.antrianno}`
  const dokterName = formData.doctor_name
  const pasienName = formData.nama_rm
  const jadwalPoli = `${defaultDateDisplay(
    formData.date_cetak_antrian,
    false,
  )} - ${toDayIndo(formData.doctor_schedule_day)} ${
    formData.doctor_schedule_time_start
  } - ${formData.doctor_schedule_time_finish}`

  const remark = isNull(formData.doctor_poliklinik_remark)
    ? ""
    : formData.doctor_poliklinik_remark

  const umur = `${formData.umur}/${
    parseInt(formData.gender_print) === 1 ? "L" : "P"
  }/${defaultDateDisplay(formData.date_ob, false)}`
  const nik = formData.nik

  const lengthNoRegis = parseInt(registrationId.toString().length)
  let addNol2 = ""
  if (lengthNoRegis !== 9) {
    for (let i = 0; i < 9 - lengthNoRegis; i++) {
      addNol2 += "0"
    }
  }
  const noRegis = `${addNol2}${registrationId}`
  const regiseMerge = `${noRM}/${noRegis}/Rawat  Jalan`
  const insuranceType = formData.insurance_name

  window.open(
    `http://localhost/${
      process.env.REACT_APP_PRINT_NAME
    }/public/api/${url}?no_antrian=${noAntrian}&dokter_name=${dokterName}&pasien_name=${pasienName}&name=${pasienName}&jadwal_poli=${jadwalPoli}&remark=${remark}&poli_name=${
      formData.poli_name
    }&no_rm=${noRM}&umur=${umur}&nik=${nik}&regis=${regiseMerge}&insurance=${insuranceType}&kunjungan_id=${registrationId}&hak_kelas=${
      formData.hak_kelas
    }&no_sep=${formData.no_sep}&waktu_estimasi_dilayani=${
      formData?.waktu_estimasi_dilayani
    }&nama_rumah_sakit=${
      printerEnv.nama_rumah_sakit
    }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${kode_setting}`,
    "MsgWindow",
  )
}

export const getTanggalRujukanPlus89Hari = (tglKunjungan) => {
  const kunjunganDate = new Date(tglKunjungan)
  if (isNaN(kunjunganDate)) {
    throw new Error("Invalid date for tglKunjungan")
  }
  return moment(kunjunganDate).add(89, "days").toDate()
}
